
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vision/[slug]",
      function () {
        return require("private-next-pages/vision/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vision/[slug]"])
      });
    }
  